module.exports = __webpack_public_path__ + "img/header_logo.05afdc80.png";